
import {defineComponent} from 'vue';

export default defineComponent({
  name: "BaseSubmittingOverlay",
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
});
